import type { NotifyOptions } from '@/registries/modals';

/** The ways a call can fail hard enough that we tear it down and say so. */
export type CallHardError = 'connection' | 'browserVersion' | 'notFound' | 'noTwoCalls' | 'media';

/**
 * The notice each hard error raises, for `callStore.stopCallOnHardError` and the
 * few places that raise one without tearing a call down.
 *
 * A keyed table rather than a `NotifyOptions` parameter at each call site,
 * because `connection` alone is reported from eleven places — passing the config
 * would paste the same three lines of German at every one of them, which is the
 * duplication this shape exists to remove.
 *
 * Its own module rather than a const in `callStore`, because `localMediaStore`
 * raises `media` and `callStore` already imports `localMediaStore`.
 */
export const CALL_HARD_ERRORS: Record<CallHardError, NotifyOptions> = {
  connection: {
    header: 'Fehler!',
    text: 'Bei der Verbindung zum Server ist ein Problem aufgetreten. Bitte erneut versuchen.',
    acknowledgeText: 'Schließen',
    acknowledgeIcon: 'icon-[mingcute--close-line]',
  },
  browserVersion: {
    header: 'Information',
    text: 'Dein Browser kann unter Umständen unsichere Protokolle verwenden. Bitte verwende einen neueren Browser.',
  },
  notFound: {
    header: 'Fehler!',
    text: 'Die Verbindung zur Videosprechstunde konnte nicht aufgebaut werden. Vermutlich wurde sie bereits beendet.',
  },
  noTwoCalls: {
    header: 'Information',
    text: 'Du kannst nur einer Sprechstunde zur Zeit beitreten.',
  },
  media: {
    header: 'Wichtig',
    text: 'Therame kann nicht auf deine Webcam und/oder dein Mikrofon zugreifen.\n\nBitte stelle sicher, dass beides in deinen Browsereinstellungen freigegeben wurde und die Webcam nicht durch andere Anwendungen blockiert wird.',
  },
};
